<template>
  <b-container fulid class="bv-example-row" style="margin-bottom:32px;">
    <div style="margin-top:20px">
      <div class="why">为什么要选易梯配</div>
      <b-row class="rows">
        <b-col cols="12" sm="12" md="12" lg="3" xl="3">
          <div class="pai_ pai_bod">
            <b-img :src="img1" class="imgs"></b-img>
            <div class="texts">
              <div class="titkuai">流量大</div>
              <div class="titkuai_2">汇聚27万电梯人</div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="5" xl="5">
          <div class="pai_ pai_bod">
            <b-img :src="img2" class="imgs"></b-img>
            <div class="texts">
              <div class="titkuai">复购高</div>
              <div class="titkuai_2">平台与客户之间建立高度信任，可产生稳定订单</div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="4" xl="4">
          <div class="pai_ pai_bod2">
            <b-img :src="img3" class="imgs"></b-img>
            <div class="texts">
              <div class="titkuai">服务好</div>
              <div class="titkuai_2">专业的客服团队承载优质的服务</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- <b-col cols="12" sm="12" md="12" lg="12" xl="12">
        <b-row class="rowwhy">
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="titkuai">流量大</b-col>
          <b-col cols="12" sm="12" md="7" lg="7" xl="7" class="txtkuai">汇聚27万电梯人</b-col>
        </b-row>
        <b-row class="rowwhy">
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="titkuai">复购高</b-col>
          <b-col cols="12" sm="12" md="7" lg="7" xl="7" class="txtkuai">平台与客户之间建立高度信任，可产生稳定订单</b-col>
        </b-row>
        <b-row class="rowwhy">
          <b-col cols="12" sm="12" md="2" lg="2" xl="2" class="titkuai">服务好</b-col>
          <b-col cols="12" sm="12" md="7" lg="7" xl="7" class="txtkuai">专业的客服团队承载优质的服务</b-col>
        </b-row>
      </b-col> -->
    </div>
  </b-container>
</template>
<script>
export default {
  name:'why',
  data(){
    return{
      img1:require('../../../stater/why1.png'),
      img2:require('../../../stater/why2.png'),
      img3:require('../../../stater/why3.png')
    }
  }
}
</script>
<style scoped>
.rows{
  border: 1px solid #ebeef5;
  box-shadow: 0px 0px 13px #0d6efd87;
}
.why{
  text-align: center;
  font-size: 27px;
  color: rgb(0 0 0 / 66%);
  font-weight: 500;
  margin-bottom: 13px;
}
.titkuai{
  /* background-color:blue; */
  background-image: linear-gradient(to right, rgb(0, 174, 255) , rgb(68, 0, 255));
    color: white;
    height: 29px;
    font-size: 14px;
    border-radius: 18px;
    width: 75px;
    line-height: 29px;
}
.txtkuai{
  color: rgb(0 0 0 / 48%);
  font-size:28px;
  text-align: left;
}
.titkuai_2{
  line-height: 39px;
  font-size: 14px;
  font-weight: 600;
}
.imgs{
  width: 60px;
  height: 60px;
  margin-right: 14px;
}
.texts{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.pai_{
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin-bottom: 14px;
  padding: 10px 0;
}
.pai_bod{
  /* border-right: 1px solid #1b5dc473; */
  height: 70px;
  margin-top: 0.8rem;
}
.pai_bod2{
  height: 70px;
  margin-top: 0.8rem;
}
@media screen and (min-width: 986px) {
  .pai_bod{
    border-right: 1px solid #1b5dc473;
  }
  .pai_bod2{
  height: 70px;
}
}
@media screen and (max-width: 500px) {
.titkuai_2{
  font-size: 12px;
}
}
</style>